module.exports = __webpack_public_path__ + "static/media/calfRays.517e6fb4.png";